var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScaleMachine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 14C8.75 12.2051 10.2051 10.75 12 10.75C13.7949 10.75 15.25 12.2051 15.25 14C15.25 15.5368 14.1833 16.8245 12.75 17.163V15C12.75 14.5858 12.4142 14.25 12 14.25C11.5858 14.25 11.25 14.5858 11.25 15V17.163C9.81665 16.8245 8.75 15.5368 8.75 14Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 4C2.25 3.58579 2.58579 3.25 3 3.25H21C21.4142 3.25 21.75 3.58579 21.75 4C21.75 4.41421 21.4142 4.75 21 4.75H15.75V7H18.2654C19.2607 7 20.1046 7.73186 20.2453 8.71716L21.6739 18.7172C21.846 19.922 20.9111 21 19.694 21H19C19 21.5523 18.5523 22 18 22C17.4477 22 17 21.5523 17 21H7C7 21.5523 6.55228 22 6 22C5.44772 22 5 21.5523 5 21H4.30602C3.08892 21 2.154 19.922 2.32612 18.7172L3.75469 8.71716C3.89545 7.73186 4.73929 7 5.73459 7H8.25V4.75H3C2.58579 4.75 2.25 4.41421 2.25 4ZM9.75 7H14.25V4.75H9.75V7ZM12 9.25C9.37665 9.25 7.25 11.3766 7.25 14C7.25 16.6234 9.37665 18.75 12 18.75C14.6234 18.75 16.75 16.6234 16.75 14C16.75 11.3766 14.6234 9.25 12 9.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScaleMachine);
export default __webpack_public_path__ + "static/media/scale-machine.664b9a1e98a1586966514c384a201359.svg";
export { ForwardRef as ReactComponent };